import {process, State} from "@progress/kendo-data-query"
import {useEffect, useRef} from "react"
import {RootState} from "../rootReducer"
import {authSettings} from "./../Config"
import {Configuration, InteractionRequiredAuthError, PublicClientApplication} from "@azure/msal-browser"
import {UserDealer} from "../containers/App/models"


export const getAccessToken = (state: RootState): string => state.application.accessToken

export const getSelectedRegionId = (state: RootState): number => state.application.selectedRegion.regionId

export const getUserId = (state: RootState): string => state.application.userInfo.idTokenClaims.oid

export const getAdminId = (state: RootState): string => state.application.userInfo.localAccountId

export const usePrevious = <T>(value: T): T | undefined => {
    const ref = useRef<T>()
    useEffect(() => {
        ref.current = value
    })
    return ref.current
}

const cfg: Configuration = {
    auth: {
        clientId: authSettings.auth.clientId,
        redirectUri: authSettings.auth.redirectUri,
        authority: authSettings.auth.authority,
    },
}

const pca = new PublicClientApplication(cfg)

export const getTokenFromAzure = async (): Promise<string> => {
    const accounts = pca.getAllAccounts()
    const account = accounts[0]

    const accessTokenRequest = {
        scopes: authSettings.auth.scopes,
        account: account,
    }

    var accessToken = ""
    await pca
        .acquireTokenSilent(accessTokenRequest)
        .then(function (accessTokenResponse) {
            accessToken = accessTokenResponse.accessToken
        })
        .catch(async function (error) {
            if (error instanceof InteractionRequiredAuthError) {
                await pca.acquireTokenPopup(accessTokenRequest).then(function (accessTokenResponse) {
                    accessToken = accessTokenResponse.accessToken
                })
            }
        })
    return accessToken
}

export const selectTestCodeByVehicleType = (vehicleType: string) => {
    if (vehicleType === "HGV") return "HGV"
    else if (vehicleType === "PSV") return "PSV22"
    else if (vehicleType === "Trailer") return "TRL"
    else return null
}

export const parseXLStrValToNum = (columnValue: string | null) => {
    // use this function if the column is alphanumeric, the exported cell will be either number or string based on the datatype without showing the parsing error
    if (columnValue === null) return ""
    const parsedColVal = parseInt(columnValue)
    return Number.isNaN(parsedColVal) ? columnValue : parsedColVal
}

export const processExportData = (data: any[], state: State) =>
    process(data, {...state, skip: undefined, take: undefined}).data

export const convertReport = (exportData: any, fileDownloadName: string) => {
    const binaryString = window.atob(exportData.fileContents)
    const bytes = new Uint8Array(binaryString.length)
    const fileName = fileDownloadName
    return createAndDownloadBlobFile(
        bytes.map((_, i) => binaryString.charCodeAt(i)),
        fileName,
    )
}

const createAndDownloadBlobFile = (body: any, fileName: any) => {
    const blob = new Blob([body])
    var navigator: any = Navigator
    if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName)
    } else {
        const link = document.createElement("a")
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob)
            link.setAttribute("href", url)
            link.setAttribute("download", fileName)
            link.style.visibility = "hidden"

            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        }
    }
}

export const calltoPreparerDealerName = (userDealers: UserDealer[], selectedDealerID: number | undefined) => {
    return userDealers.filter(x => x.preparerId).find((x: UserDealer) => x.dealerId === selectedDealerID)?.dealerName
}
